import { useMutation } from '../';
import { deletePortfolioMutation } from '../mutations';

export function useDeletePortfolioMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(deletePortfolioMutation, variables, () => {
      if (onFinish) {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
